module.exports = __webpack_public_path__ + "img/platform.c06a227d.svg";